const getConfig = () => {
  return {
    REACT_ENV: process.env.REACT_APP_REACT_ENV,
    GTM_ID: process.env.REACT_APP_GTM_ID,
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL
  };
};

export default getConfig;
